import { Form } from "antd";
import { OptList } from "./Model";
import { TitleBar } from "./Model";
const RadioList = (props) => {
  const handleCheck = (item) => {
    const { value = [], onChange } = props;
    let _value = [...value];
    let index = _value.findIndex((o) => o.position.toString() === item.position.toString());
    _value.forEach((item, i) => {
      item.checked = i === index ? true : false;
    });
    if (index < 0) _value.push({ answerId: item.id, position: item.position, checked: true, source: item });
    onChange(_value);
  };
  return <OptList {...props} type="radio" onCheck={handleCheck}></OptList>;
};

const RadioViews = (props) => {
  const { info } = props;
  return (
    <div className="components-input-views">
      <TitleBar info={info}></TitleBar>
      <div className="opt-list radio-list">
        <Form.Item name={["postAnswer", info.position]}>
          <RadioList list={info.answerList}></RadioList>
        </Form.Item>
      </div>
    </div>
  );
};

export default RadioViews;
